import React from "react";
import classnames from "classnames";

import styles from "./LanguageSwitch.module.scss";
import { useConfig } from "@src/components/providers/ConfigProvider";
import { AvailableLanguages } from "@src/types";

export const LanguageSwitch: React.FC = () => {
  const { lang, setLang } = useConfig();

  const languages: AvailableLanguages[] = ["en", "pl", "de"];

  return (
    <div className={styles.root}>
      {languages.map((language) => (
        <span
          key={language}
          onClick={() => setLang(language)}
          className={classnames(styles.languageLabel, { [styles.active]: lang === language })}
        >
          {language.toUpperCase()}
        </span>
      ))}
    </div>
  );
};
